import { render } from "./MoveIcon.vue?vue&type=template&id=514282a0"
import script from "./MoveIcon.vue?vue&type=script&lang=js"
export * from "./MoveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__